import axiosInstance from "../../../helpers/api";

export const getAllSubjects = (body) => {
  return axiosInstance.get("/superadmin/subjects", body);
};

export const editSubjects = (formData) => {
  console.log(formData, "api");
  return axiosInstance.post(
    `/superadmin/subjects/${formData.id}`,
    formData.formData
  );
};

export const restrictSubjects = (formData) => {
  return axiosInstance.post(
    `/superadmin/subjects/restrict/${formData.id}`,
    formData.formData
  );
};
export const asquaraSubjects = (formData) => {
  return axiosInstance.post(
    `/superadmin/subjects/set_asquera/${formData.id}`,
    formData.formData
  );
};
export const activeSubjects = (formData) => {
  return axiosInstance.post(
    `/superadmin/subjects/activate/${formData.id}`,
    formData.formData
  );
};

export const createSubjects = (formData) => {
  return axiosInstance.post("/superadmin/subjects", formData);
};

export const deleteSubject = (id) => {
  return axiosInstance.delete(`/superadmin/subjects/${id}`);
};
